import React from 'react';
import {Layout, Text} from '@phonectas/unifon-ui-kit';
import {StyledTextDiv, StyledLabel} from './styled';

interface TextDivWithLabelProps {
    text: string;
    label?: string;
    noBorder?: boolean;
    smBorderRadius?: boolean;
    whiteSpaceNormal?: boolean;
    secondaryText?: string;
}

const TextDivWithLabel: React.FC<TextDivWithLabelProps> = ({
	label,
	text,
	secondaryText,
	noBorder = false,
	smBorderRadius = false,
	whiteSpaceNormal = false,
}) => {
	return (
		<>
			<Layout fullWidth gap="sm">
				{label && (
					<StyledLabel>
						{label}
					</StyledLabel>
				)}
				<StyledTextDiv
					$noBorder={noBorder}
					$smBorderRadius={smBorderRadius}
					$whiteSpaceNormal={whiteSpaceNormal}
				>
					<Text variant="body1">{text}</Text>
					{
						secondaryText && (
							<Text variant="body1">{secondaryText}</Text>
						)
					}
				</StyledTextDiv>
			</Layout>
		</>
	);
}

export default TextDivWithLabel;
